import { assignInlineVars } from '@vanilla-extract/dynamic';
import { useTheme } from 'next-themes';
import { type CSSProperties, useMemo } from 'react';
import { Toaster } from 'sonner';

import type { NotificationCenterProps } from '../types';
import { cardWrapper } from './styles.css';

const toastOptions = {
  style: {
    width: '100%',
  },
  className: cardWrapper,
};

// Map custom/preset themes to Sonner's 'light' or 'dark'
// Blue-white is a hybrid theme with dark UI chrome, so toasts should be dark
function getSonnerTheme(resolvedTheme: string | undefined): 'light' | 'dark' {
  if (!resolvedTheme) return 'light';
  // Preset themes with dark UI chrome
  if (resolvedTheme === 'blue-white') return 'dark';
  // Standard themes
  if (resolvedTheme === 'dark') return 'dark';
  return 'light';
}

export function DesktopNotificationCenter({
  width = 380,
}: NotificationCenterProps) {
  const theme = useTheme();
  const sonnerTheme = getSonnerTheme(theme.resolvedTheme);
  const style = useMemo(() => {
    return {
      ...assignInlineVars({
        // override css vars inside sonner
        '--width': `${width}px`,
      }),
      // radix-ui will lock pointer-events when dialog is open
      pointerEvents: 'auto',
    } satisfies CSSProperties;
  }, [width]);

  return (
    <Toaster
      className="affine-notification-center"
      style={style}
      toastOptions={toastOptions}
      theme={sonnerTheme}
    />
  );
}
